/* Autogenerated file, do not edit! */
import { EventSelector, loadContractArtifact, loadContractArtifactForPublic } from '@aztec/aztec.js/abi';
import { Contract, ContractBase, DeployMethod } from '@aztec/aztec.js/contracts';
import { Fr } from '@aztec/aztec.js/fields';
import { PublicKeys } from '@aztec/aztec.js/keys';
import TrainContractArtifactJson from './train-Train.json';
export const TrainContractArtifact = loadContractArtifact(TrainContractArtifactJson);
/**
 * Type-safe interface for contract Train;
 */
export class TrainContract extends ContractBase {
    constructor(address, wallet) {
        super(address, TrainContractArtifact, wallet);
    }
    /**
     * Creates a contract instance.
     * @param address - The deployed contract's address.
     * @param wallet - The wallet to use when interacting with the contract.
     * @returns A new Contract instance.
     */
    static at(address, wallet) {
        return Contract.at(address, TrainContract.artifact, wallet);
    }
    /**
     * Creates a tx to deploy a new instance of this contract.
     */
    static deploy(wallet) {
        return new DeployMethod(PublicKeys.default(), wallet, TrainContractArtifact, (instance, wallet) => TrainContract.at(instance.address, wallet), Array.from(arguments).slice(1));
    }
    /**
     * Creates a tx to deploy a new instance of this contract using the specified public keys hash to derive the address.
     */
    static deployWithPublicKeys(publicKeys, wallet) {
        return new DeployMethod(publicKeys, wallet, TrainContractArtifact, (instance, wallet) => TrainContract.at(instance.address, wallet), Array.from(arguments).slice(2));
    }
    /**
     * Creates a tx to deploy a new instance of this contract using the specified constructor method.
     */
    static deployWithOpts(opts, ...args) {
        return new DeployMethod(opts.publicKeys ?? PublicKeys.default(), opts.wallet, TrainContractArtifact, (instance, wallet) => TrainContract.at(instance.address, wallet), Array.from(arguments).slice(1), opts.method ?? 'constructor');
    }
    /**
     * Returns this contract's artifact.
     */
    static get artifact() {
        return TrainContractArtifact;
    }
    /**
     * Returns this contract's artifact with public bytecode.
     */
    static get artifactForPublic() {
        return loadContractArtifactForPublic(TrainContractArtifactJson);
    }
    static get storage() {
        return {
            user_locks: {
                slot: new Fr(1n),
            },
            solver_locks: {
                slot: new Fr(2n),
            },
            solver_lock_count: {
                slot: new Fr(3n),
            }
        };
    }
    static get events() {
        return {
            UserRefunded: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::UserRefunded"
                },
                eventSelector: EventSelector.fromString("0x25768aed"),
                fieldNames: ["hashlock"],
            },
            UserRedeemed: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "redeemer",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "secret",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::UserRedeemed"
                },
                eventSelector: EventSelector.fromString("0x4dea76c1"),
                fieldNames: ["hashlock", "redeemer", "secret"],
            },
            UserLocked: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "sender",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "src_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "dst_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_address",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "dst_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_recipient",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "reward_timelock_delta",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "quote_expiry",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "userData",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "solverData",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::UserLocked"
                },
                eventSelector: EventSelector.fromString("0x93b4b4cc"),
                fieldNames: ["hashlock", "sender", "recipient", "src_chain", "token", "amount", "timelock", "dst_chain", "dst_address", "dst_amount", "dst_token", "reward_amount", "reward_token", "reward_recipient", "reward_timelock_delta", "quote_expiry", "userData", "solverData"],
            },
            SolverRefunded: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "index",
                            "type": {
                                "kind": "field"
                            }
                        }
                    ],
                    "path": "Train::SolverRefunded"
                },
                eventSelector: EventSelector.fromString("0x6256200f"),
                fieldNames: ["hashlock", "index"],
            },
            SolverRedeemed: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "index",
                            "type": {
                                "kind": "field"
                            }
                        },
                        {
                            "name": "redeemer",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "secret",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::SolverRedeemed"
                },
                eventSelector: EventSelector.fromString("0xc977b58b"),
                fieldNames: ["hashlock", "index", "redeemer", "secret"],
            },
            SolverLocked: {
                abiType: {
                    "kind": "struct",
                    "fields": [
                        {
                            "name": "hashlock",
                            "type": {
                                "kind": "array",
                                "length": 32,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "sender",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "index",
                            "type": {
                                "kind": "field"
                            }
                        },
                        {
                            "name": "src_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "reward_token",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "reward_recipient",
                            "type": {
                                "kind": "struct",
                                "fields": [
                                    {
                                        "name": "inner",
                                        "type": {
                                            "kind": "field"
                                        }
                                    }
                                ],
                                "path": "aztec::protocol_types::address::aztec_address::AztecAddress"
                            }
                        },
                        {
                            "name": "timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "reward_timelock",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 64
                            }
                        },
                        {
                            "name": "dst_chain",
                            "type": {
                                "kind": "array",
                                "length": 30,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_address",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "dst_amount",
                            "type": {
                                "kind": "integer",
                                "sign": "unsigned",
                                "width": 128
                            }
                        },
                        {
                            "name": "dst_token",
                            "type": {
                                "kind": "array",
                                "length": 90,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        },
                        {
                            "name": "data",
                            "type": {
                                "kind": "array",
                                "length": 256,
                                "type": {
                                    "kind": "integer",
                                    "sign": "unsigned",
                                    "width": 8
                                }
                            }
                        }
                    ],
                    "path": "Train::SolverLocked"
                },
                eventSelector: EventSelector.fromString("0x9ac68aa8"),
                fieldNames: ["hashlock", "sender", "recipient", "index", "src_chain", "token", "amount", "reward", "reward_token", "reward_recipient", "timelock", "reward_timelock", "dst_chain", "dst_address", "dst_amount", "dst_token", "data"],
            }
        };
    }
}
